/* Product 3D wiring. Lives in an external asset on purpose: the theme editor's preview blocks
   inline scripts but runs external ones, so this must never be inlined. */
(function () {
  function diag(msg) {
    var els = document.querySelectorAll('[data-p3d-diag]');
    for (var i = 0; i < els.length; i++) { els[i].textContent = '3D-diagnos: ' + msg; }
  }

  function ensureLib(host) {
    if (window.customElements && customElements.get('model-viewer')) return;
    if (document.querySelector('script[data-p3d-lib]')) return;
    var sc = document.createElement('script');
    sc.type = 'module';
    sc.setAttribute('data-p3d-lib', '');
    sc.src = host.getAttribute('data-lib');
    document.head.appendChild(sc);
  }

  function wire(host) {
    if (host.dataset.p3dReady) return;
    host.dataset.p3dReady = '1';
    ensureLib(host);
    var mv = host.querySelector('model-viewer');
    if (!mv) { diag('inget model-viewer-element i sektionen'); return; }
    diag('skript kör — laddar bibliotek/modell …');
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      mv.removeAttribute('auto-rotate');
    }
    function reveal() { host.classList.add('is-ready'); }
    mv.addEventListener('load', function () { reveal(); diag('modell laddad ✓ (klick på en feature roterar)'); });
    mv.addEventListener('error', function (e) {
      var d = e && e.detail;
      diag('FEL: ' + ((d && d.type) || 'okänt') + ' ' + ((d && d.sourceError && d.sourceError.message) || ''));
    });
    setTimeout(reveal, 6000); /* never leave the pulse running forever */
  }

  function scan(root) {
    var els = (root || document).querySelectorAll('[data-p3d]');
    for (var i = 0; i < els.length; i++) { wire(els[i]); }
  }

  /* Feature clicks via delegation — survives any editor re-render. First click kills idle spin. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.p3d__btn') : null;
    if (!b) return;
    var sec = b.closest('section');
    var mv = sec ? sec.querySelector('model-viewer') : null;
    if (!mv) return;
    var all = sec.querySelectorAll('.p3d__btn');
    for (var i = 0; i < all.length; i++) { all[i].classList.toggle('is-active', all[i] === b); }
    mv.removeAttribute('auto-rotate');
    /* auto-rotate spins the turntable (the model itself); camera targets are world-fixed, so any
       accumulated spin makes every view land slightly off. Reset it before aiming. */
    if (typeof mv.resetTurntableRotation === 'function') { mv.resetTurntableRotation(); }
    mv.setAttribute('camera-orbit', b.getAttribute('data-orbit'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else { scan(document); }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; scan(document); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
